"use client"

import React from 'react';
import type { MenuProps } from 'antd';
import { Dropdown as CDropdown } from 'antd';

interface IDropdownProps {
    children: React.ReactNode;
    options?: MenuProps;
    className?: string;
    onOpenChange?: ((open: boolean, info: {
        source: "trigger" | "menu";
    }) => void) | undefined,
    placement?: "topLeft" | "topCenter" | "topRight" | "bottomLeft" | "bottomCenter" | "bottomRight" | "top" | "bottom";
}

const Dropdown: React.FC<IDropdownProps> = ({
    children, options, onOpenChange, placement = 'bottomRight', className
}) => (
    <CDropdown
        menu={options}
        trigger={['click']}
        placement={placement}
        onOpenChange={onOpenChange}
        className={className}
    >
        {children}
    </CDropdown>
);

export default Dropdown;
